import { mainSiteUrl } from '@/mocks/categories';

const comparisonData = [
  {
    label: 'Product Discovery',
    traditional: 'Manual search across multiple sources, time-consuming browsing',
    superbuy: 'Organized spreadsheet with direct product links, instant access',
    improvement: 'Faster by 85%',
  },
  {
    label: 'Product Organization',
    traditional: 'Scattered bookmarks and notes, easy to lose track',
    superbuy: 'Categorized collections with structured data fields',
    improvement: 'Better organized',
  },
  {
    label: 'Price Comparison',
    traditional: 'Manually checking prices one by one across sellers',
    superbuy: 'Side-by-side comparison with pricing columns built in',
    improvement: 'Save 40% time',
  },
  {
    label: 'QC Information',
    traditional: 'No QC reference, rely on seller photos only',
    superbuy: 'QC photo guides and quality check criteria included',
    improvement: 'More informed',
  },
  {
    label: 'Research Time',
    traditional: 'Hours of scattered research across forums and sites',
    superbuy: 'Consolidated resources in one spreadsheet',
    improvement: 'Reduced 80%',
  },
  {
    label: 'Decision Making',
    traditional: 'Overwhelmed by too many unorganized options',
    superbuy: 'Clear comparison framework for confident choices',
    improvement: 'More confident',
  },
];

export default function ComparisonSection() {
  return (
    <section id="resources" className="py-16 md:py-24 bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <div className="lg:w-1/3">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 text-white/70 text-xs font-medium mb-4">
              Compare Table
            </span>
          </div>
          <div className="lg:w-2/3">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight">
              Why Superbuy Spreadsheet Wins
            </h2>
          </div>
        </div>

        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-white/20">
                <th className="py-4 pr-8 text-white/60 text-xs font-medium uppercase tracking-wider whitespace-nowrap">
                  Feature
                </th>
                <th className="py-4 px-6 text-white/60 text-xs font-medium uppercase tracking-wider whitespace-nowrap">
                  Traditional Shopping
                </th>
                <th className="py-4 px-6 text-accent-400 text-xs font-medium uppercase tracking-wider whitespace-nowrap">
                  Superbuy Spreadsheet
                </th>
                <th className="py-4 pl-6 text-white/60 text-xs font-medium uppercase tracking-wider whitespace-nowrap">
                  Improvement
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={idx} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                  <td className="py-5 pr-8 text-white font-semibold text-sm whitespace-nowrap">
                    {row.label}
                  </td>
                  <td className="py-5 px-6 text-white/50 text-sm leading-relaxed">
                    {row.traditional}
                  </td>
                  <td className="py-5 px-6 text-accent-300 text-sm leading-relaxed font-medium">
                    {row.superbuy}
                  </td>
                  <td className="py-5 pl-6 text-secondary-400 text-sm font-semibold whitespace-nowrap">
                    {row.improvement}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="md:hidden grid grid-cols-1 gap-4">
          {comparisonData.map((row, idx) => (
            <div key={idx} className="bg-white/10 rounded-lg p-5">
              <h4 className="text-white font-semibold text-sm mb-3">{row.label}</h4>
              <div className="flex flex-col gap-2 text-xs">
                <div className="flex gap-2">
                  <span className="text-white/40 shrink-0">Traditional:</span>
                  <span className="text-white/60">{row.traditional}</span>
                </div>
                <div className="flex gap-2">
                  <span className="text-accent-400 shrink-0">Superbuy:</span>
                  <span className="text-accent-300">{row.superbuy}</span>
                </div>
                <div className="flex gap-2 mt-1 pt-2 border-t border-white/10">
                  <span className="text-secondary-400 font-semibold">{row.improvement}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all"
          >
            Experience the Difference
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}